import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WeatherSunIcon width={12} />
 */
export const WeatherSunIcon = props => (
    <SvgIcon {...props}>
        <path d="M11.25 4.75V1H12.75V4.75H11.25ZM17.65 7.4L16.6 6.35L19.25 3.675L20.3 4.75L17.65 7.4ZM19.25 12.75V11.25H23V12.75H19.25ZM11.25 23V19.25H12.75V23H11.25ZM6.325 7.375L3.7 4.75L4.75 3.7L7.4 6.35L6.325 7.375ZM19.275 20.3L16.6 17.65L17.625 16.625L20.325 19.225L19.275 20.3ZM1 12.75V11.25H4.75V12.75H1ZM4.775 20.3L3.7 19.25L6.325 16.625L6.875 17.125L7.425 17.65L4.775 20.3ZM12 18C10.3333 18 8.91667 17.4167 7.75 16.25C6.58333 15.0833 6 13.6667 6 12C6 10.3333 6.58333 8.91667 7.75 7.75C8.91667 6.58333 10.3333 6 12 6C13.6667 6 15.0833 6.58333 16.25 7.75C17.4167 8.91667 18 10.3333 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18ZM12 16.5C13.25 16.5 14.3125 16.0625 15.1875 15.1875C16.0625 14.3125 16.5 13.25 16.5 12C16.5 10.75 16.0625 9.6875 15.1875 8.8125C14.3125 7.9375 13.25 7.5 12 7.5C10.75 7.5 9.6875 7.9375 8.8125 8.8125C7.9375 9.6875 7.5 10.75 7.5 12C7.5 13.25 7.9375 14.3125 8.8125 15.1875C9.6875 16.0625 10.75 16.5 12 16.5Z" />
    </SvgIcon>
)

WeatherSunIcon.defaultProps = defaultProps
